import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { EpGridComponent, IEpGridModel, IEpGridState, IEPGridDataResult, EpGridEvent, IEpGridSelectionOptions, EpButtonStyle, IEpComponentEventArg } from '@epicor/kinetic';
import { Observable } from 'rxjs';
import { IEpBtCardControlModel, BistrackConfig } from 'ep-bt-controls';

import { ActivatedRoute } from '@angular/router';
import { IEpCardModel } from '@epicor/kinetic';
import { FieldAgentClient, GetCustomerAddressHeadersRequest, SearchParameters } from 'ep-bt-field-agent-proxy';
import { Router, NavigationExtras } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { PagingParameters, SortParameters, SortParametersDirection } from 'ep-bt-field-agent-proxy';
import { EpbtFaSortService } from '../../services/epbt-fa-sort.service';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-address-grid',
  templateUrl: './epbt-fa-address-grid.component.html',
  styleUrls: ['./epbt-fa-address-grid.component.scss']
})
export class EpbtFaAddressGridComponent implements OnInit {

  dockType = 'horizontal';
  EpButtonStyle = EpButtonStyle;

  private _customerId;
  address: any;
  @Input() customerId: number;

  private _searchString: string;

  @Input('searchString') set searchString(value: string) {
    this._searchString = value;
  }

  get searchString(): string { return this._searchString; }

  @ViewChild('emailTemplate', {static: true}) emailTemplate: TemplateRef<any>;
  @ViewChild('addressTemplate', {static: true}) addressTemplate: TemplateRef<any>;
  @ViewChild(EpGridComponent, {static: false}) grid: EpGridComponent;

  showGrid = true;
  public gridModel: IEpGridModel;
  public pageSize = 10;
  public cards: Array<IEpBtCardControlModel>;

  cardModels: IEpGridModel[] = [];
  cardModel: IEpGridModel;
  webTrackUser: any;
  customerAddressRequest: GetCustomerAddressHeadersRequest;
  paging: PagingParameters;
  sort: SortParameters;
  webtrackResult: any;

  @Output() loadingChange = new EventEmitter<boolean>();
  addressCollection: any = [];
  totalPages = 1;
  pageArray: Array<number> = [];
  lastPage: number;
  lastRecords: any;
  mobileData: any;
  isLastRecords = false;
  isMoreEnable = false;

  constructor(private client: FieldAgentClient, private route: ActivatedRoute, private router: Router,
    private fieldAgentService: EpbtFieldAgentService, private config: BistrackConfig,
    private sortService: EpbtFaSortService, private customerService: EpbtFaCustomerService) { }



  ngOnInit() {
    this._customerId = this.customerId;
    // var bistrackSettings = this.fieldAgentService.getBisTrackSetting();

    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.pageSize = bistrackSettings.searchPageSize;
    });


    // this.webTrackUser = this.fieldAgentService.getWebTrackUser();

    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
      this.gridModel = this.getGridModel([]);
    });
    // this.gridModel = this.getGridModel();
    // this.getGridData();
    // this.fieldAgentService.getWebTrackUser().subscribe(webTrackRes => {
    //       this.webTrackUser = webTrackRes;
    //       console.log(this.webTrackUser, 'address webstrack user id');
    //       this.gridModel = this.getGridModel();
    //       this.getGridData();
    // });

  }

  updateGrid() {
    const calHeight = this.getHeight();
    this.gridModel.height = calHeight;
  }


  // grid model start
  getGridModel(addressList): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'userData.addressCode',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      pageable: true,
      pageSize: this.pageSize,
      scrollable: 'scrollable',
      rowHeight: 20,
      sortable: false,
      height: this.getHeight(),
      selectionOptions: selectionOptions,
      data: addressList,
      columns: [
        { field: 'userData.addressCode', title: 'ADDRESS CODE', width: 80, hidden: false },
        { field: 'userData.jobRef', title: 'JOB REFERENCE', width: 60, hidden: false },
        { field: 'userData.contactName', title: 'CONTACT', width: 100, hidden: false },
        { field: 'userData.address', title: 'ADDRESS', width: 120, hidden: false },
        { field: 'userData.map', title: 'MAP', width: 50, hidden: false, class: 'color-blue', cellTemplate: this.addressTemplate }
      ],
      epOnComponentEvent: (eventArg: IEpComponentEventArg) => {
        if (eventArg.eventId == 'epOnCellClick' && eventArg.event && eventArg.event.type == 'click') {
          this.navigateToDetailsView(eventArg.event.dataItem);
        }
      },
      // fnEvent: (event: EpGridEvent, args: any) => {
      //   if (event === EpGridEvent.cellClick) {
      //     this.navigateToDetailsView(args.dataItem);
      //   }
      // },
      loader: (epGrid: EpGridComponent, state: IEpGridState) => {
        const observerResult = this.getGridModelData(epGrid, state, addressList, false);
        return observerResult;
      }
    };

    $(window).resize(() => {

      this.updateGrid();
    });
    return model;
  }


  getGridModelData(epGrid: EpGridComponent, state: IEpGridState, addressList, isMobile: boolean): Observable<IEPGridDataResult> {
    const observerResult = new Observable<IEPGridDataResult>(observer => {
      const index = state.skip + state.take;
      const pageNumber = Math.ceil(index / state.take);
      const pageIndex = this.pageArray.indexOf(pageNumber);
      if ((pageIndex >= 0 && !isMobile) || (pageNumber == this.lastPage && this.lastRecords && this.lastRecords.length > 0 && !isMobile)) {
        epGrid.model.loadingIndicator = false;
        const showoff = pageNumber == this.lastPage ? this.lastRecords : this.addressCollection.slice(state.take * pageIndex, (state.take * pageIndex) + state.take);
        const result: IEPGridDataResult = {
          data: showoff,
          total: this.totalPages
        };
        observer.next(result);
        observer.complete();
      } else {
        if (!isMobile) {
          epGrid.model.loadingIndicator = true;
        }
        this.customerAddressRequest = new GetCustomerAddressHeadersRequest();
        this.customerAddressRequest.currentUser = this.webTrackUser;
        this.customerAddressRequest.currentUser.customer.customerId = this.customerId;

        this.paging = new PagingParameters();
        this.paging.index = state.skip;
        this.paging.count = this.pageSize;
        this.customerAddressRequest.paging = this.paging;

        this.sort = new SortParameters();
        this.sort.sortColumn = this.sortService.customerAddressSortValue; // 'AddressCode';
        this.sort.direction = this.sortService.customerAddressDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
        this.customerAddressRequest.sorting = this.sort;

        const customerAddressSearchParameter = new SearchParameters();
        customerAddressSearchParameter.paging = this.paging;
        customerAddressSearchParameter.sorting = this.sort;
        customerAddressSearchParameter.customerId = this.customerId;

        this.customerAddressRequest.searchParameters = customerAddressSearchParameter;
        this.customerAddressRequest.searchParameters.searchText = this._searchString;

        this.client.getCustomerAddressHeaders(this.customerAddressRequest).subscribe(res => {
          if (res && res.lines && res.lines.length > 0) {
            this.customerService.isDefaultAddress = false;
            addressList = [];
            res.lines.forEach(data => {
              const cardModel: any = {
                userData: {
                  id: data.address.addressId,
                  contactName: data.contactName,
                  address: this.getAddressData(data.address),
                  addressCode: data.address.addressCode,
                  jobRef: data.jobRef
                }
              };
              addressList.push(cardModel);
            });
            this.totalPages = res.resultCount;
            this.lastPage = Math.ceil(this.totalPages / state.take);
            if (pageNumber != this.lastPage) {
              this.pageArray.push(pageNumber);
            }

            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            if (addressList.length < state.take) {
              this.lastRecords = addressList;
            } else {
              this.addressCollection = [...this.addressCollection, ...addressList];
            }
            if (!isMobile) {
              this.mobileData = this.addressCollection;
              if (this.lastRecords && this.lastRecords.length > 0) {
                this.mobileData = [...this.mobileData, ...this.lastRecords];
              }
              this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
            }

            length = this.addressCollection.length;
            const result: IEPGridDataResult = {
              data: addressList,
              total: this.totalPages
            };
            observer.next(result);
            observer.complete();
          } else {
            const result: IEPGridDataResult = {
              data: [],
              total: 0
            };
            observer.next(result);
            observer.complete();
            if (!isMobile) {
              epGrid.model.loadingIndicator = false;
            }
            this.isMoreEnable = false;
            this.mobileData = this.mobileData ? this.mobileData : [];
          }
        });
      }
      this.loadingChange.emit(false);
    });
    return observerResult;
  }

  // grid model end

  // grid height calculation start

  getHeight(): number {
    const height = $(window).outerHeight() - 283;
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad 273
      return 400;
    }

    if (this.dockType != 'vertical') {
      // horizontal
      return height - 70;
    } else {
      return height / 2 - 80;
    }


  }
  // grid height calculation end
  // api call start

  // getGridData() {
  //   this.cardModels = [];
  //   this.customerAddressRequest = new GetCustomerAddressHeadersRequest();
  //   this.customerAddressRequest.currentUser = this.webTrackUser;
  //   this.customerAddressRequest.currentUser.customer.customerId = this.customerId;

  //   this.paging = new PagingParameters();
  //   this.paging.index = 0;
  //   this.paging.count = this.pageSize;
  //   this.customerAddressRequest.paging = this.paging;

  //   this.sort = new SortParameters();
  //   this.sort.sortColumn = 'AddressCode';
  //   this.sort.direction = SortParametersDirection.Ascending;
  //   this.customerAddressRequest.sorting = this.sort;

  //   let customerAddressSearchParameter = new SearchParameters();
  //   customerAddressSearchParameter.paging = this.paging;
  //   customerAddressSearchParameter.sorting = this.sort;
  //   customerAddressSearchParameter.customerId = this.customerId;

  //   this.customerAddressRequest.searchParameters = customerAddressSearchParameter;
  //   this.customerAddressRequest.searchParameters.searchText = this._searchString;

  //   this.client.getCustomerAddressHeaders(this.customerAddressRequest).subscribe(res => {

  //     if (res != null) {
  //       res.lines.forEach(data => {
  //         let cardModel: IEpGridModel =
  //         {
  //           userData: {
  //             id: data.address.addressId,
  //             contactName: data.contactName,
  //             address: this.getAddressData(data.address),
  //             addressCode: data.address.addressCode,
  //             jobRef: data.jobRef
  //           }
  //         }
  //         this.cardModels.push(cardModel);
  //       })
  //     }


  //     this.gridModel.data = this.cardModels;

  //   });


  // }

  // api call end

  // address field mapping start

  // getAddressData(addressObj: any) {
  //   let address = '';
  //   // (addressObj.addressId) ? address += addressObj.addressId : '';
  //   // (addressObj.addressCode) ? address += ', ' + addressObj.addressCode : '';
  //   (addressObj.address1) ? address += addressObj.address1 : '';
  //   (addressObj.city) ? address += ', ' + addressObj.city : '';
  //   (addressObj.county) ? address += ', ' + addressObj.county : '';
  //   (addressObj.postCode) ? address += ', ' + addressObj.postCode : '';
  //   (addressObj.country) ? address += ', ' + addressObj.country : '';
  //   return address;
  // }

  // This method will combines the full address of map
  getAddressData(addressObj: any) {
    const address = [addressObj.address1, addressObj.address2,
    addressObj.address3, addressObj.city,
    addressObj.county, addressObj.postCode, addressObj.country].filter(Boolean).join(', ');
    return address;
  }

  // address field mapping end


  // add button function start

  getMobileData() {
    const take = this.pageSize;
    for (let i = 1; i <= this.lastPage; i++) {
      const index = this.pageArray.indexOf(i);
      if (index == -1) {
        const state: IEpGridState = {
          skip: (i - 1) * take,
          take: take
        };
        let epGrid: EpGridComponent;
        this.getGridModelData(epGrid, state, [], true).subscribe(res => {
          if (res.data && res.data.length > 0) {
            let j = 0;
            if (res.data.length == state.take) {
              res.data.forEach(element => {
                this.mobileData.splice((state.take * (i - 1)) + j, 0, element);
                j++;
              });
            }
            if (this.lastRecords && this.lastRecords.length > 0 && !this.isLastRecords) {
              this.mobileData = [...this.mobileData, ...this.lastRecords];
              this.isLastRecords = true;
            }
            this.isMoreEnable = this.mobileData.length == this.totalPages ? false : true;
          }
        });
        break;
      }
    }
  }


  updateGridData() {
    this.lastPage = 0;
    this.lastRecords = undefined;
    this.mobileData = undefined;
    this.isLastRecords = false;
    this.pageArray.length = 0;
    this.isMoreEnable = false;
    this.gridModel = undefined;
    this.showGrid = false;
    this.addressCollection.length = 0;
    setTimeout(() => {
      this.showGrid = true;
      this.loadingChange.emit(true);
      this.gridModel = this.getGridModel([]);
    }, 200);
    // this.getGridData();
  }

  navigateToDetailsView(args) {
    // let navigationExtras: NavigationExtras = {
    //   queryParams: {
    //     'addressId': args.userData.id,
    //     'customerId': this.customerId,
    //     'contactName': args.userData.contactName
    //   },
    //   skipLocationChange: true
    // };

    // // this.router.navigate(['/home/customer/addressdetails'], navigationExtras);

    // this.router.navigate(['/home/customer/addaddress'], navigationExtras);
    this.router.navigate(['/home/customer/addaddress', this.customerId, args.userData.id]);
  }

  onCardClick(model) {
    this.navigateToDetailsView(model);
  }
  // add button function end
}
